export default __webpack_public_path__ + "static/headshot-color-337db00756e5ad6ec10692fa9ddbb589.jpg";